import { $body, $window, $html } from '../utils/environment';
import AbstractModule from './AbstractModule';

const SELECTOR = {
    CLOSE: `.js-close-popup`
}

export default class extends AbstractModule {
    constructor(options) {
        super(options);

        this.init();
    }

    init() {
        this.$popup = $(this.$el[0])

        this.$popup.on('click.Popup', SELECTOR.CLOSE, (e) => this.close(e))

        let closeTs = window.localStorage.getItem('volleyball-popup-close') ? parseInt(window.localStorage.getItem('volleyball-popup-close')) : false;
        let now = Date.now()

        const POPUP_TIMEOUT = 1440000 // 24h

        if(!closeTs || (now - closeTs > POPUP_TIMEOUT)) {
            $html.addClass('has-popup-open')
        }
    }

    close(e){
        $html.removeClass('has-popup-open')

        window.localStorage.setItem('volleyball-popup-close', Date.now())
    }

    destroy() {
        this.$popup.off('.Popup')
    }
}
